import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import ToolBar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import React, { useState } from "react";
import logo from "../../assets/logo192.png";
import classes from "./LayoutHeader.module.scss";
import { useNavigate } from "react-router-dom";
import { isClassExpression } from "typescript";
import noAvatorIcon from "../../assets/noAvatar.png";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
import HeaderMenu from "../uikit/molecules/HeaderMenu";
import EmailIcon from "@mui/icons-material/Email";
import { useLogoutOAuth2 } from "../../hooks/useLogoutOauth2";
import { accessTokenState } from "../../states/accessTokenState";
import { useMobile } from "../../hooks/token/useMobile";
const LayoutHeader = () => {
  const theme = useTheme();
  const navigation = useNavigate();
  const user = useRecoilValue(userState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { logout } = useLogoutOAuth2();
  const accessToken = useRecoilValue(accessTokenState);
  const { isMobile } = useMobile();
  console.log("isMobile", isMobile, user.isAuth, accessToken);
  //ロゴクリック
  const handleLogoClick = (e: React.MouseEvent<HTMLElement>) => {
    if (!user.isAuth || !accessToken) return;
    navigation("/");
    //スクロールする処理を記述
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } catch (error) {
      // just a fallback for older browsers
      window.scrollTo(0, 0);
    }
  };
  //メニューボタンクリック
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    if ((user?.isAuth && accessToken) || (isMobile && user?.isAuth)) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClickLogOut = async () => {
    // logoutFromGoogleWithResetCache();
    await logout();
    handleClose();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <header className={classes.root}>
      <AppBar position="fixed" sx={{ bgcolor: theme.palette.backColor.dark }}>
        <ToolBar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className={classes.toolBar}
        >
          <div className={classes.leftMenu}>
            <img
              src={logo}
              alt="Logo"
              className={classes.logo}
              onClick={handleLogoClick}
            />
            {user.isAuth && accessToken ? (
              <HeaderMenu />
            ) : isMobile && user.isAuth ? (
              <HeaderMenu />
            ) : (
              <> </>
            )}
          </div>
          <div className={classes.rightMenu}>
            <div className={classes.vDivider} />
            <div className={classes.userArea}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
              >
                <Typography
                  variant="body1"
                  component="div"
                  className={classes.userName}
                  sx={{
                    color: theme.palette.foreColor.light,
                    marginRight: "5px",
                    "&:hover": {
                      color: theme.palette.foreColor.main,
                    },
                  }}
                >
                  {user?.isAuth && accessToken
                    ? user?.workerName
                    : isMobile && user?.isAuth
                    ? user?.workerName
                    : ""}
                </Typography>
                <img
                  src={
                    user?.isAuth && accessToken
                      ? user?.photoURL
                      : isMobile && user?.isAuth
                      ? user?.photoURL
                      : noAvatorIcon
                  }
                  alt=""
                  className={classes.noAvatorIcon}
                />
              </IconButton>
            </div>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              sx={{
                "& .MuiPaper-root": {
                  // Paperコンポーネントに対するスタイル
                  backgroundColor: theme.palette.backColor.dark,
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "conter",
                  paddingLeft: "10px",
                  marginBottom: "10px",
                }}
              >
                {/* <ListItemIcon> */}
                <ExitToAppIcon
                  style={{ color: theme.palette.foreColor.light }}
                />
                {/* </ListItemIcon> */}
                <MenuItem
                  onClick={handleClickLogOut}
                  style={{ color: theme.palette.foreColor.light }}
                >
                  ログアウト
                </MenuItem>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "conter",
                  paddingLeft: "10px",
                  marginBottom: "0px",
                  paddingTop: "10px",
                  borderTop: "1px solid #333",
                }}
              >
                {/* <ListItemIcon> */}
                <EmailIcon style={{ color: theme.palette.foreColor.light }} />
                {/* </ListItemIcon> */}
                <MenuItem
                  onClick={() => {
                    navigation("/outsourcing-mail-setting");
                    handleClose();
                  }}
                  style={{ color: theme.palette.foreColor.light }}
                >
                  外注メール
                </MenuItem>
              </div>
            </Menu>
          </div>
        </ToolBar>
      </AppBar>
    </header>
  );
};

export default LayoutHeader;
